import { useEffect, useState, type FormEvent } from 'react';
import { adminApi, type Subscriber } from '../../lib/adminApi';

export function Newsletter() {
  const [subscribers, setSubscribers] = useState<Subscriber[]>([]);
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [sending, setSending] = useState(false);
  const [note, setNote] = useState('');

  useEffect(() => {
    adminApi.getState().then((state) => setSubscribers(state.subscribers)).catch(() => undefined);
  }, []);

  const send = async (event: FormEvent) => {
    event.preventDefault();
    if (!subject.trim() || !body.trim()) return;
    setSending(true);
    setNote('');
    try {
      const result = await adminApi.broadcast(subject.trim(), body.trim());
      setNote(result.delivered ? `Sent to ${result.sent} subscriber${result.sent === 1 ? '' : 's'}.` : `Queued for ${result.sent} subscriber${result.sent === 1 ? '' : 's'} (Resend not configured — nothing was delivered).`);
      setSubject('');
      setBody('');
    } catch (error) {
      setNote(error instanceof Error ? error.message : 'Could not send the broadcast.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="cms-page">
      <div className="cms-page-head">
        <h1>Newsletter</h1>
        <p>Announce a new litter or update to everyone who signed up on the site.</p>
      </div>

      <div className="cms-two-col">
        <section className="cms-card">
          <form onSubmit={send}>
            <label className="cms-field"><span>Subject</span><input value={subject} onChange={(event) => setSubject(event.target.value)} placeholder="A new litter is on the way" /></label>
            <label className="cms-field"><span>Message</span><textarea rows={8} value={body} onChange={(event) => setBody(event.target.value)} placeholder="Write your announcement…" /></label>
            <div className="cms-reply-actions">
              {note && <span className="cms-reply-note">{note}</span>}
              <button type="submit" className="cms-btn cms-btn-primary" disabled={sending || !subject.trim() || !body.trim() || !subscribers.length}>{sending ? 'Sending…' : `Send to ${subscribers.length}`}</button>
            </div>
          </form>
        </section>

        <section className="cms-section">
          <h2>Subscribers ({subscribers.length})</h2>
          {subscribers.length ? (
            <ul className="cms-list">
              {subscribers.map((subscriber) => (
                <li key={subscriber.id}><span>{subscriber.email}</span><time>{new Date(subscriber.createdAt).toLocaleDateString()}</time></li>
              ))}
            </ul>
          ) : <p className="cms-empty">No subscribers yet.</p>}
        </section>
      </div>
    </div>
  );
}
